module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_c_una_tinta-e64c3e2db9524d51ebf5fe2a91e5e197.svg";